var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-select",
    {
      class: { "v-select-danger": _vm.danger, "select-size-sm": _vm.small },
      attrs: {
        name: _vm.name,
        value: _vm.optionSelected,
        options: _vm.optionsList,
        disabled: _vm.isDisabled,
        clearable: _vm.clearable,
        placeholder: _vm.computedPlaceholder,
        selectable: function(opt) {
          return !opt.disabled
        }
      },
      on: { input: _vm.onInput },
      scopedSlots: _vm._u([
        {
          key: "spinner",
          fn: function() {
            return [
              _vm.titleState.loading
                ? _c("b-spinner", { attrs: { small: "", variant: "primary" } })
                : _vm._e()
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("template", { slot: "no-options" }, [
        _vm._v(" No hay opciones para el criterio de búsqueda ")
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }